import React from 'react';
import useProduct from '../../PageProduct/useProduct';
import { Form } from '@dashboard/components/Formik';

const FilesForm = () => {
  const { product, updateProduct } = useProduct();

  return (
    <Form
      autosave
      showState={false}
      initialValues={{
        enableFileAccessForInactiveSubscriptions: product?.enableFileAccessForInactiveSubscriptions,
      }}
      onSubmit={async values => {
        const { data, error } = await updateProduct.mutateAsync(values);

        return {
          data,
          error,
        };
      }}
      fields={[
        {
          name: 'enableFileAccessForInactiveSubscriptions',
          label: 'Allow file downloads after subscription cancellation',
          type: 'toggle',
        },
      ]}
    />
  );
};

export default FilesForm;
